<template>
  <div>
    <h3 class="title mb-3 green--text">Contratante</h3>
    <p>
      <strong>Nome Fantasia: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.contratanteNomeFantasia : "" }}
    </p>
    <p>
      <strong>Razão Social: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.contratanteCartao : "" }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Beneficiario",
  props: {
    beneficiarioPinss: Object
  }
};
</script>

<style scoped lang="scss">
.pinss {
  p {
    margin-bottom: 8px;
  }
}
</style>
